import { useState } from "react";

import { useEditDiscountMutation } from "@modules/discounts/services/mutations";
import { FeaturedDiscountSwitchProps } from "./types";

export function useFeaturedDiscountSwitch({ id, value }: FeaturedDiscountSwitchProps) {
  const [isFeatured, setIsFeatured] = useState(value);

  const { mutateAsync, isPending } = useEditDiscountMutation(id);

  const toggle = async () => {
    await mutateAsync({
      featured: !isFeatured,
    });

    setIsFeatured((prev) => !prev);
  }

  return { isFeatured, isPending, toggle };
}
